import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ThemeMode from './ThemeMode';

import Email from '../image/email.svg';
import Project from '../image/project.svg';
import Home from '../image/home.svg';
import Footer from './Footer';

const Nav = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollDown = () => {
    window.scrollTo({
      top: scrollPosition + 700,
      behavior: 'smooth',
    });
  };

  return (
    <div className='hidden lg:flex flex-col justify-center sm:justify-start items-center h-screen w-[10%] sm:p-0 sm:m-0 gap-20 text-sm'>
      <ThemeMode />
      {/* Large screen */}
      <ul className='flex flex-col w-full gap-6'>
        <li>
          <Link to='/' className='flex flex-col items-center gap-1 cursor-pointer hover:underline' onClick={handleScrollDown}>
            <img src={Home} alt='email' className='h-6 w-6 hover:scale-150 transform transition-transform transition-500' />
            <p>Home</p>
          </Link>
        </li>
        <li>
          <Link to='/contact' className='flex flex-col items-center gap-1 cursor-pointer hover:underline' onClick={handleScrollDown}>
            <img src={Email} alt='email' className='h-6 w-6 hover:scale-150 transform transition-transform transition-500' />
            <p>Contact</p>
          </Link>
        </li>
        <li>
          <Link to='/project' className='flex flex-col items-center gap-1cursor-pointer hover:underline' onClick={handleScrollDown}>
            <img src={Project} alt='email' className='h-6 w-6 hover:scale-150 transform transition-transform transition-500' />
            <p>Project</p>
          </Link>
        </li>
      </ul>
      <Footer />
    </div>
  );
};

export default Nav;